import { entriesReducerFactory } from '@/fleet-configuration/data-fleet/entries/entries-reducer-factory'
import { SET_CHAIN_CATALOG_COMPONENT } from './chain-catalog-actions.js'

export const chainCatalogReducer = entriesReducerFactory(SET_CHAIN_CATALOG_COMPONENT)
